import { Stack, Text } from '@ltvco/refresh-lib/theme';
import { LoadingDots } from '@ltvco/refresh-lib/v1';
import CloseIcon from '@mui/icons-material/Close';
import { useContext } from 'react';

import { ReportColumnContainer } from 'components/ChatBV/components';
import { ChatLayoutContext } from 'components/ChatBV/context';
import { useCourtCaseDetails } from 'routes/Dashboard/CourtCases/v2/shared/hooks';
import { Court, CourtDocket } from 'routes/Dashboard/CourtCases/v2/types';

import { CourtCaseAttachments } from './CourtCaseAttachments';
type CourtCaseColumnProps = {
  currentWidth: string;
  isMobileBreakpoint: boolean;
  onClose: () => void;
};

export const CourtCaseColumn = ({
  currentWidth,
  isMobileBreakpoint,
  onClose,
}: CourtCaseColumnProps) => {
  const { reportState } = useContext(ChatLayoutContext);
  const { currentCourtCaseId } = reportState;
  const { docketQuery, courtQuery, isLoading } =
    useCourtCaseDetails(currentCourtCaseId);

  const { data: docketData, isLoading: isDocketLoading } = docketQuery;
  const { data: courtData, isLoading: isCourtLoading } = courtQuery;

  const isDataLoading = isDocketLoading || isCourtLoading || isLoading;

  return (
    <ReportColumnContainer
      spacing={2}
      minWidth={currentWidth}
      width="30%"
      height="98%"
      sx={{
        px: 1,

        ...(isMobileBreakpoint && {
          animation: 'fadeInScale 0.4s ease-out',
          '@keyframes fadeInScale': {
            '0%': {
              transform: 'scale(0.95)',
              opacity: 0,
            },
            '100%': {
              transform: 'scale(1)',
              opacity: 1,
            },
          },
        }),
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        sx={{
          position: 'sticky',
          top: 0,
          backgroundColor: 'background.paper',
          zIndex: 1,
          padding: '16px 20px',
        }}
      >
        <Text variant="body1" fontWeight="bold" color="text.primary">
          Attachments
        </Text>
        <CloseIcon
          role="button"
          tabIndex={0}
          aria-label="Close attachments panel"
          onClick={onClose}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              onClose();
            }
          }}
          sx={{ color: 'text.secondary', cursor: 'pointer' }}
        />
      </Stack>
      {isDataLoading ? (
        <LoadingDots count={3} />
      ) : (
        <CourtCaseAttachments
          currentDocketId={docketData?.id?.toString() || ''}
          courtCaseId={currentCourtCaseId || ''}
          docketData={docketData as CourtDocket}
          courtData={courtData as Court}
        />
      )}
    </ReportColumnContainer>
  );
};
